module.exports = __webpack_public_path__ + "img/zone300350.846af501.png";